import { render, staticRenderFns } from "./CategoryCustom.vue?vue&type=template&id=0248fea8"
import script from "./CategoryCustom.vue?vue&type=script&lang=js"
export * from "./CategoryCustom.vue?vue&type=script&lang=js"
import style0 from "./CategoryCustom.vue?vue&type=style&index=0&id=0248fea8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports